import React from "react";
import { useTranslation } from 'react-i18next';

function Card({ title, price, description, detailedDescription, scrollToPage}) {
    const { t } = useTranslation();
    return (
        <div className="card">
            <h3>{title}</h3>
            <p className="card-description">{description}</p>
            <p className="card-price">{price}</p>
            <div className="card-details">{detailedDescription}</div>
            <button onClick={scrollToPage}>{t('book_button')}</button>
        </div>
    );

}
export default Card;